var map = {
	"./": "986a",
	"./format": "8071",
	"./format.js": "8071",
	"./index": "986a",
	"./index.js": "986a",
	"./lang/en": "9de3",
	"./lang/en.js": "9de3",
	"./lang/it": "b235",
	"./lang/it.js": "b235"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ce4";